'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EpisodechangereportController = function EpisodechangereportController($scope, DTOptionsBuilder, DTColumnBuilder, CONST, materialButtons, datePicker, $rootScope, FunctionService, $filter, CoderService, Constants, ModalService) {
  _classCallCheck(this, EpisodechangereportController);

  this.datatableApi;
  this.name = 'Episode Change';
  this.startDate = moment().subtract(1, 'months').format("DD/MM/YYYY");
  this.endDate = moment().format("DD/MM/YYYY");
  this.separationString = '';
  this.locale = 'en-au';
  this.url = WEBSERVICEURL + '/dataagility/api/service.episodechangereport';
  this.startDatePicker = {
    input: {
      date: moment($scope.vm.startDate, "DD/MM/YYYY").locale($scope.vm.locale),
      dateFormatted: $scope.vm.startDate
    }
  };
  this.endDatePicker = {
    input: {
      date: moment($scope.vm.endDate, "DD/MM/YYYY").locale($scope.vm.locale),
      dateFormatted: $scope.vm.endDate
    }
  };
  this.dischargeUnit = {
    selectedDischargeUnit: []
  };
  this.dischargeUnitOptions = {};

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.dischargeUnitOptions = response.specialties;
  });

  this.coder = {
    selectedCoder: []
  };
  this.coderOptions = [];
  this.coderOptionsWithIds = {};
  this.selectedCoderIds = [];

  this.createdBy = {
    selectedCreatedBy: [],
    selectedCreatedByIds: []
  };
  this.createdByOptions = [];
  this.createdByOptionsWithIds = [];

  CoderService.data().then(function successCallback(response) {
    angular.forEach(response, function (item, key) {
      $scope.vm.coderOptions.push(item.name);
      $scope.vm.coderOptionsWithIds[item.name] = item.id;
      $scope.vm.createdByOptions.push(item.name);
      $scope.vm.createdByOptionsWithIds[item.name] = item.id;
    });
  });

  this.episodeChangeType = {
    selectedEpisodeChangeType: []
  };
  this.episodeChangeTypeOptions = [];

  ModalService.getIncDocTypes().then(function (response) {
    angular.forEach(response.INCDOCTYPES, function (item, key) {
      if (item.isActive && item.toggleModalTypeId === 1) {
        $scope.vm.episodeChangeTypeOptions.push(item.toggleLabel);
      }
    });
    $scope.vm.episodeChangeTypeOptions.sort();
  });

  this.episodeActiveOptions = {
    activeOnly: 'Active Episodes Only',
    allEpisodes: 'All Episodes'
  };
  this.episodeActive = this.episodeActiveOptions.activeOnly;
  this.episodeActiveChoices = Object.values(this.episodeActiveOptions);

  this.episodeOpenOptions = {
    open: 'Open',
    closed: 'Completed',
    all: 'Open and Completed'
  };
  this.episodeOpen = this.episodeOpenOptions.open;
  this.episodeOpenChoices = Object.values(this.episodeOpenOptions);

  this.dateTypeDefaultId = 1;
  this.dateTypeOptions = [{ id: 0, value: 'Date Created' }];
  this.dateType = { id: this.dateTypeDefaultId = 1 };

  $scope.vm.selectedDateTypeId = this.dateType.id;

  this.search = '';

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
    var option = { id: $scope.vm.dateTypeDefaultId, value: $scope.vm.separationString + ' Date' };
    $scope.vm.dateTypeOptions.push(option);
    $scope.vm.dateType = $scope.vm.dateTypeOptions[1];
  });

  datePicker.autoClose($scope);
  materialButtons.render();
  materialButtons.processing();
  $scope.initCallback = function () {

    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;
    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);
    search();

    // Set the table to a fixed height, so it never collapses up or down
    $('#auditTable').closest(".dataTables_scrollBody").height(300);
  };

  $scope.drawCallback = function (nRow) {

    // Tell DataTables we're using Aussie-formatted dates for ordering
    $.fn.dataTable.moment('DD/MM/YYYY HH:mm');
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
    headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
    url: $scope.vm.url + '?startDate=' + this.startDatePicker.input.dateFormatted + '&endDate=' + this.endDatePicker.input.dateFormatted + '&dateType=' + $scope.vm.dateType.id,
    type: 'GET',
    error: function error(xhr, _error, thrown) {
      if (thrown == 'Unauthorized') {
        //window.location.replace(window.location.origin + '/login');
        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
      }
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($('#auditTable').DataTable());
  }).withOption('rowCallback', $scope.rowCallback).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('aaSorting', [[0, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    'extend': 'print',
    'text': ''
  }, {
    'extend': 'csvHtml5',
    'text': '',
    'filename': $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    'extend': 'excelHtml5',
    'text': '',
    'filename': $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    'text': '',
    'action': function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]);

  this.dtColumns = [DTColumnBuilder.newColumn('urn').withOption('defaultContent', '').withTitle('URN').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('episodeNumber').withOption('defaultContent', '').withTitle('Episode').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withOption('defaultContent', '').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withOption('defaultContent', '').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeUnit').withOption('defaultContent', '').withTitle('Unit').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('originalCoder').withOption('defaultContent', '').withTitle('Original Coder').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('episodeChangeType').withOption('defaultContent', '').withTitle('Episode Change Type').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('comments').withOption('defaultContent', '').withTitle('Comments').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('createdBy').withOption('defaultContent', '').withTitle('Created By').withClass('mdl-data-table__cell--non-numeric')];

  this.dischargeUnitCallback = dischargeUnitCallback;

  function dischargeUnitCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  this.filterDischargeUnit = filterDischargeUnit;

  function filterDischargeUnit(swap) {
    $scope.vm.dischargeUnit.selectedDischargeUnit = [];
    if (swap === 'add') {
      angular.forEach($scope.vm.dischargeUnitOptions, function (value, key) {
        $scope.vm.dischargeUnit.selectedDischargeUnit.push($scope.vm.dischargeUnitOptions[$scope.vm.dischargeUnitOptions.indexOf(value)]);
      });
    }
  }

  this.coderCallback = coderCallback;

  function coderCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  this.filterCoder = filterCoder;

  function filterCoder(swap) {
    $scope.vm.coder.selectedCoder = [];
    if (swap === 'add') {
      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions;
    }
  }

  this.episodeChangeTypeCallback = episodeChangeTypeCallback;

  function episodeChangeTypeCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  this.filterEpisodeChangeType = filterEpisodeChangeType;

  function filterEpisodeChangeType(swap) {
    $scope.vm.episodeChangeType.selectedEpisodeChangeType = [];
    if (swap === 'add') {
      angular.forEach($scope.vm.episodeChangeTypeOptions, function (value, key) {
        $scope.vm.episodeChangeType.selectedEpisodeChangeType.push($scope.vm.episodeChangeTypeOptions[$scope.vm.episodeChangeTypeOptions.indexOf(value)]);
      });
    }
  }

  this.filterCreatedBy = filterCreatedBy;

  function filterCreatedBy(swap) {
    $scope.vm.createdBy.selectedCreatedBy = [];
    $scope.vm.createdBy.selectedCreatedByIds = [];
    if (swap === 'add') {
      angular.forEach($scope.vm.createdByOptions, function (value, key) {
        $scope.vm.createdBy.selectedCreatedBy.push($scope.vm.createdByOptions[$scope.vm.createdByOptions.indexOf(value)]);
      });
    }
  }

  function checkParam(param) {

    if (param && param.length && param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  this.changeData = changeData;

  function changeData() {

    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
        endDate = $scope.vm.endDatePicker.input.dateFormatted,
        selectedDateType = $scope.vm.selectedDateTypeId,
        selectedDischargeUnit = $scope.vm.dischargeUnit.selectedDischargeUnit,
        selectedCoder = $scope.vm.coder.selectedCoder,
        selectedCoderIds = $scope.vm.selectedCoderIds,
        selectedCreatedBy = $scope.vm.createdBy.selectedCreatedBy,
        selectedCreatedByIds = $scope.vm.createdBy.selectedCreatedByIds,
        selectedEpisodeChangeType = $scope.vm.episodeChangeType.selectedEpisodeChangeType,
        selectedEpisodeActive = $scope.vm.episodeActive === $scope.vm.episodeActiveOptions.allEpisodes ? 0 : 1,
        selectedEpisodeOpen = $scope.vm.episodeOpen,
        searchString = $scope.vm.search,
        newUrl = $scope.vm.url + '?startDate=' + startDate + '&endDate=' + endDate + '&dateType=' + selectedDateType + '&dischargeUnit=' + checkParam(selectedDischargeUnit) + '&coder=' + checkParam(selectedCoder) + '&coderIds=' + checkParam(selectedCoderIds) + '&createdBy=' + checkParam(selectedCreatedBy) + '&createdByIds=' + checkParam(selectedCreatedByIds) + '&episodeChangeType=' + checkParam(selectedEpisodeChangeType) + '&episodeActive=' + selectedEpisodeActive + '&episodeOpen=' + String(selectedEpisodeOpen) + '&search=' + String(searchString || '');

    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
  }

  function setDtHeaders(table) {
    $(table.column(3).header()).html($scope.vm.separationString + ' Date');
  }

  function search() {

    filterDischargeUnit('minus');
    filterCoder('minus');
    // filterCampus('minus');

    $scope.$on('lx-date-picker__close-start', function (e, id) {

      $scope.vm.changeData();
    });
  }

  this.setDateType = setDateType;

  function setDateType(newValue) {
    $scope.vm.dateType = newValue;
    $scope.vm.selectedDateTypeId = newValue.id;
    $scope.vm.selectedDateTypeValue = newValue.value;
    $scope.vm.changeData();
  }
  this.setCoder = setCoder;

  function setCoder(newValue) {
    $scope.vm.selectedCoder = newValue;

    $scope.vm.selectedCoderIds = [];
    angular.forEach($scope.vm.selectedCoder, function (model, index) {
      $scope.vm.selectedCoderIds.push($scope.vm.coderOptionsWithIds[model]);
    });

    $scope.vm.changeData();
  }

  this.setCreatedBy = setCreatedBy;

  function setCreatedBy(newValue) {
    $scope.vm.selectedCreatedBy = newValue;

    $scope.vm.createdBy.selectedCreatedByIds = [];
    angular.forEach($scope.vm.selectedCreatedBy, function (model) {
      $scope.vm.createdBy.selectedCreatedByIds.push($scope.vm.createdByOptionsWithIds[model]);
    });

    $scope.vm.changeData();
  }

  // Bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }
};

exports.default = EpisodechangereportController;


// WEBPACK FOOTER //
// ./client/app/common/reports/episodechangereport/episodechangereport.controller.js